import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

function CloseMenu({ closeMenu, children }) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    closeMenu();
  }, [location, closeMenu]);

  return children;
}

export default CloseMenu;
